


export const menuItems = [

    {
        id: 1,
        label: "Tình năng",
        isTitle: true,
        show: ['admin', 'member']
    },
    {
        id: 2,
        label: "Thành Viên",
        icon: "bx bx-user-circle",
        show: ['admin'],
        subItems: [
            {
                id: 3,
                label: "Thêm tài khoản ",  //bx-calendar
                link: "/them-thanh-vien",
                show: ['admin'],
                parentId: 2,
            },
            {
                id: 4,
                label: "Danh sách tài khoản",  //bx-calendar
                link: "/danh-sach-thanh-vien",
                show: ['admin'],
                parentId: 2,
            }
        ]
    },
    {
        id: 5,
        label: "Trang quản lý",
        icon: "bx bx-task",
        show: ['member'],
        link: "/trang-quan-ly",
    },
    {
        id: 6,
        label: "Dịch Vụ",
        icon: "bx bx-task",
        show: ['admin'],
        link: "/danh-sach-dich-vu",
        // subItems: [
        //     {
        //         id: 7,
        //         label: "Danh Sách",
        //         link: "/danh-sach-dich-vu",
        //         parentId: 6,
        //         show: ['admin']
        //     }
        // ]
    },
   

    {
        id: 10,
        label: "Khách hàng",
        icon: "bx bx-user",
        show:['admin','member'],
        link: "/quan-ly-khach-hang"
    },
  
    {
        id: 30,
        label: "Đơn hàng",
        icon: "bx bx-aperture",
        link: "/danh-sach-don-hang",
        show: ['admin', 'member'],
        // subItems: [
        //     {
        //         id: 31,
        //         label: "Danh Sách",
        //         link: "/danh-sach-don-hang",
        //         parentId: 30,
        //         show: ['admin', 'member']
        //     }
        // ]
    },

    

    {
        id: 40,
        label: "Hóa đơn",
        icon: "bx-receipt",
        show:['admin','member'],
        link: "/danh-sach-hoa-don",
        // subItems: [
           
        //     {
        //         id: 41,
        //         label: "Mẫu Hóa Đơn",
        //         link: "/mau-hoa-don",
        //         parentId: 40,
        //         show:['admin']
        //     },
        //     {
        //         id: 42,
        //         label: "Danh sách hóa đơn",
        //         link: "/danh-sach-hoa-don",
        //         parentId: 40,
        //         show:['admin','member']
        //     }
        // ]
    },
    {
        id: 50,
        label: "Bảng Lương",
        icon: "bx bx-notepad",
        link: "/quan-ly-luong",
        show:['admin'],
    },
    {
        id: 52,
        label: "Doanh số",
        icon: "bx bx-notepad",
        link: "/thong-ke-doanh-so",
        show:['member'],
    },
    {
        id: 60,
        label: "Báo cáo tài chính",
        icon: "bx bx-spreadsheet",
        show:['admin'],
        link: "/tong-ket-tai-chinh",
        // subItems: [
        //     {
        //         id: 62,
        //         label: "Báo cáo tài chính",
        //         link: "/tong-ket-tai-chinh",
        //         parentId: 60,
        //         show:['admin']
        //     }
        // ]
    },
    {
        id: 70,
        label: "Mẫu hóa đơn",
        icon: "bx bx-mail-send",
        show:['admin'],
        link: "/mau-hoa-don"
    },
   
];